export default __webpack_public_path__ + "static/media/AntiguaCasonaSanBlas.18205c78.png";